import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import { initAppShell } from './app-shell/index.js';
import { registerServiceWorker } from './cache/register-sw.js';

window.jQuery = window.$ = $;

function initViewportScale() {
  const body = document.body;
  if (!body.classList.contains('has-viewport-scale')) {
    return;
  }

  const canvas = document.querySelector('.viewport-scale-canvas');
  if (!canvas) {
    return;
  }

  const vw = parseInt(canvas.getAttribute('data-viewport-width'), 10) || 1920;
  const vh =
    parseInt(canvas.getAttribute('data-viewport-height'), 10) ||
    parseInt(body.getAttribute('data-viewport-height'), 10) ||
    1080;

  body.style.transform = '';
  body.style.marginLeft = '';
  body.style.marginTop = '';
  canvas.style.width = vw + 'px';
  canvas.style.height = vh + 'px';

  function viewportWidth() {
    return window.visualViewport ? window.visualViewport.width : window.innerWidth;
  }

  function viewportHeight() {
    return window.visualViewport ? window.visualViewport.height : window.innerHeight;
  }

  function apply() {
    const w = viewportWidth();
    const h = viewportHeight();
    const sc = Math.min(w / vw, h / vh);
    canvas.style.transform = 'scale(' + sc + ')';
    canvas.style.left = (w - vw * sc) / 2 + 'px';
    canvas.style.top = (h - vh * sc) / 2 + 'px';
  }

  window.addEventListener('resize', apply);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', apply);
  }
  apply();
}

function initInactivityTimeout() {
  const INACTIVITY_TIMEOUT = 5 * 60 * 1000;
  let inactivityTimer = null;

  function resetInactivityTimer() {
    if (inactivityTimer) {
      window.clearTimeout(inactivityTimer);
    }

    inactivityTimer = window.setTimeout(function () {
      window.location.href = window.location.pathname + '#cover';
    }, INACTIVITY_TIMEOUT);
  }

  const activityEvents = ['mousemove', 'click', 'keydown', 'touchstart', 'scroll'];
  activityEvents.forEach(function (event) {
    document.addEventListener(event, resetInactivityTimer);
  });

  resetInactivityTimer();
}

$(function () {
  initAppShell();
  initViewportScale();
  registerServiceWorker();
  initInactivityTimeout();

  $.fn.extend({
    toggleText: function (a, b) {
      return this.text(this.text() === b ? a : b);
    }
  });
});

window.addEventListener('load', function () {
  svg4everybody();
});
